/**
 * Cognito / Amplify からの英語エラーメッセージをユーザ向け日本語に変換する。
 * 該当するパターンが無ければ null を返す（呼び出し側でフォールバック表示）。
 */
export const translateCognitoMessage = (
  message: string | undefined,
): string | null => {
  if (!message) return null;
  if (
    message.includes("Invalid session for the user") ||
    message.includes("session is expired")
  ) {
    return "セッションが切れました。お手数ですが再読み込みしてやり直してください。";
  }
  if (
    message.includes("Invalid code provided") ||
    message.includes("Invalid verification code")
  ) {
    return "認証コードが正しくありません。メールに届いたコードを再度ご確認ください。";
  }
  if (message.includes("Attempt limit exceeded")) {
    return "試行回数の上限に達しました。しばらく時間をおいてから再度お試しください。";
  }
  // PRODUCT_DEV-415 ID/パスワード認証失敗
  if (
    message.includes("Incorrect username or password") ||
    message.includes("NotAuthorizedException")
  ) {
    return "ユーザーネームかパスワードが一致しません";
  }
  // PRODUCT_DEV-396 パスキー関連
  if (message.includes("Access Token has been revoked")) {
    return "アクセストークンは取り消されました。お手数ですが再ログインしてください。";
  }
  if (message.includes("Passkey registration ceremony has been canceled")) {
    return "パスキー登録操作はキャンセルされました。";
  }
  if (message.includes("Passkey already exists in authenticator")) {
    return "このパスキーはすでに登録されています。別のデバイスをお試しいただくか、既存のパスキーを削除してから再度登録してください。";
  }
  return null;
};
